import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import HeaderPageTitle from "../../../layouts/inc/HeaderPageTitle";
import useTranslations from "../../../i18n/useTranslations";
import { usePageContent } from "../../../i18n/useContentMap";

import ModalPartnerQRCode from "../../../components/modal/ModalPartnerQRCode";

import img_icoArrowRight from "../../../assets/img/ci/profile/ico-arrow-right.svg";
import img_imgIconUser from "../../../assets/img/ci/profile/img-icon-user.svg";
import img_icoPdpa from "../../../assets/img/ci/profile/ico-pdpa.svg";
import img_icoPolicy from "../../../assets/img/ci/profile/ico-policy.svg";
import img_icoWebsite from "../../../assets/img/ci/profile/ico-website.svg";
import img_icoMail from "../../../assets/img/ci/profile/ico-mail.svg";
import img_icoCallcenter from "../../../assets/img/ci/profile/ico-callcenter.svg";
import img_icoLanguage from "../../../assets/img/ci/profile/ico-language.svg";
import img_icoPartner from "../../../assets/img/ci/profile/ico-partner.svg";

const Profile = () => {
  const stateProfile = useSelector((state) => state.profile);
  const { t, lang, getCurrentLanguageName } = useTranslations();
  const content = usePageContent("profile");
  const [isPartnerAccordionOpen, setIsPartnerAccordionOpen] = useState(false);
  const accordionContentRef = useRef(null);
  const [accordionHeight, setAccordionHeight] = useState(0);

  /* Handle goto page */
  const navigate = useNavigate();

  const handleGotoPage = (e) => {
    e.preventDefault();
    // console.log("click GotoPage", e.currentTarget.dataset.page);

    const page = e.currentTarget.dataset.page;
    navigate("/" + page);
  };
  /* End Handle goto page */

  /* Handle accordion toggle */
  const handleTogglePartnerAccordion = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPartnerAccordionOpen(!isPartnerAccordionOpen);
  };
  /* End Handle accordion toggle */

  /* Measure accordion content height */
  useEffect(() => {
    if (accordionContentRef.current) {
      const contentHeight = accordionContentRef.current.scrollHeight;
      setAccordionHeight(contentHeight);
    }
  }, [isPartnerAccordionOpen]);

  useEffect(() => {
    // Measure initial height on mount
    if (accordionContentRef.current) {
      const contentHeight = accordionContentRef.current.scrollHeight;
      setAccordionHeight(contentHeight);
    }
  }, []);
  /* End Measure accordion content height */

  /* First event render */
  useEffect(() => {
    // console.log("useEffect !", stateProfile);

    if (Object.getOwnPropertyNames(stateProfile.dataUser).length === 0) {
      navigate("/");
    }
  }, []);
  /* End First event render */

  /* Modal partner qr code */
  const [isModalPartnerQRCodeShow, setIsModalPartnerQRCodeShow] =
    useState(false);

  const handleOpenModalPartnerQRCode = () => {
    setIsModalPartnerQRCodeShow(true);
  };

  const handleCloseModalPartnerQRCode = () => {
    setIsModalPartnerQRCodeShow(false);
  };
  /* End Modal partner qr code */

  return (
    <>
      <Helmet>
        <title>Paypoint</title>
        <meta name="title" content="Paypoint" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="Paypoint" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Paypoint" />
      </Helmet>

      <div id="pageProfile">
        <main>
          <div className="wrapContent">
            <HeaderPageTitle title={content.title} prevPage="/member" />

            <section id="pProfile">
              <div className="bProfile">
                <div className="bTitle">
                  <div className="bImg">
                    {/* <img src={img_imgProfile} alt="" /> */}
                    <img src={stateProfile.lineImgUrl} alt="" />
                  </div>
                  <p className="tName">{stateProfile.dataUser.fullname}</p>
                  <p>ID: {stateProfile.id}</p>
                </div>

                <div className="bProfileSelect">
                  <div
                    className="bMenu"
                    onClick={handleGotoPage}
                    data-page="profile-detail"
                  >
                    <div className="bIcon">
                      <img src={img_imgIconUser} alt="" />
                      <p>{t("profile.viewProfile")}</p>
                    </div>
                    <img src={img_icoArrowRight} alt="" />
                  </div>
                  <div
                    className="bMenu"
                    onClick={handleGotoPage}
                    data-page="term-and-conditions"
                  >
                    <div className="bIcon">
                      <img src={img_icoPdpa} alt="" />
                      <p>
                        {t("profile.termAndConditions")}
                      </p>
                    </div>
                    <img src={img_icoArrowRight} alt="" />
                  </div>
                  <div
                    className="bMenu"
                    onClick={handleGotoPage}
                    data-page="privacy-policy"
                  >
                    <div className="bIcon">
                      <img src={img_icoPolicy} alt="" />
                      <p>
                        {t("profile.privacyPolicy")}
                      </p>
                    </div>
                    <img src={img_icoArrowRight} alt="" />
                  </div>

                  {stateProfile?.dataUser?.customerType === "the_point" && (
                    <div className="bMenu partner">
                      <div
                        className={`btnAccordPartner ${
                          isPartnerAccordionOpen ? "opened" : ""
                        }`}
                        onClick={handleTogglePartnerAccordion}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="bIcon">
                          <img src={img_icoPartner} alt="" />
                          <p>{t("profile.partner.managePartner")}</p>
                        </div>
                        <img src={img_icoArrowRight} alt="" />
                      </div>
                      <div
                        ref={accordionContentRef}
                        className={`contentAccordPartner ${
                          isPartnerAccordionOpen ? "open" : ""
                        }`}
                        style={{
                          maxHeight: isPartnerAccordionOpen
                            ? `${accordionHeight}px`
                            : "0",
                          marginTop: isPartnerAccordionOpen ? "0" : "-20px",
                          display: "block",
                          overflow: "hidden",
                          transition:
                            "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), margin-top 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                      >
                        <div className="bList">
                          <a
                            className="add btnModalQrCode"
                            onClick={handleOpenModalPartnerQRCode}
                          >
                            <span>{t("profile.partner.addPartner")}</span>
                          </a>
                          <a
                            className="list"
                            onClick={handleGotoPage}
                            data-page="partner/list"
                          >
                            <span>{t("profile.partner.listPartner")}</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className="bMenu"
                    onClick={handleGotoPage}
                    data-page="questionnaire"
                  >
                    <div className="bIcon">
                      <img src={img_icoPdpa} alt="" />
                      <p>
                        {t("profile.questionnaire")}
                      </p>
                    </div>
                    <img src={img_icoArrowRight} alt="" />
                  </div>
                  <div
                    className="bMenu"
                    onClick={handleGotoPage}
                    data-page="language"
                  >
                    <div className="bIcon">
                      <img src={img_icoLanguage} alt="" />
                      <p>
                        {t("navigation.language")}
                        <span>{getCurrentLanguageName()}</span>
                      </p>
                    </div>
                    <img src={img_icoArrowRight} alt="" />
                  </div>
                </div>
                <div className="bContact">
                  <p>{t("profile.contactUs")}</p>
                  <div className="group-contract">
                    <div className="tContact">
                      <img src={img_icoWebsite} alt="" />
                      <a href="https://welcomepaypoint.com/" target="_blank">
                        {t("profile.tpdWebsite")}
                      </a>
                    </div>
                    <div className="tContact">
                      <img src={img_icoMail} alt="" />
                      <a href="mailto:info@welcomepaypoint.com">
                        info@welcomepaypoint.com
                      </a>
                    </div>
                    <div className="tContact">
                      <img src={img_icoCallcenter} alt="" />
                      <a href="tel:02-764-6606">
                        {t("profile.contactCenter")}{" "}
                        02-764-6606
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <ModalPartnerQRCode
            open={isModalPartnerQRCodeShow}
            onClose={handleCloseModalPartnerQRCode}
            custFullname={stateProfile.dataUser.fullname}
            custId={stateProfile.id}
          />
        </main>
      </div>
    </>
  );
};

export default Profile;
